import React, { useEffect, useState } from "react";
import { loadFaqs, loadSection } from "../services/contentSource";
import Seo from "../components/Seo";
import faqData from "../data/faqData.json";
import headerFallback from "../data/faqPageHeader.json";

const Faqs = () => {
  const [faqs, setFaqs] = useState<any[]>(faqData.faqs || []);
  const [header, setHeader] = useState<any>(headerFallback);

  useEffect(() => {
    loadFaqs().then((data) => {
      if (data) setFaqs(data);
    });
    loadSection("faqPage", headerFallback as any).then(({ data: main }) => {
      if (main) setHeader(main);
    });
  }, []);

  return (
    <>
      <Seo
        title="FAQs"
        description="Common questions about MindSyncX products, deployment, data handling and support."
        path="/faqs"
      />
      <link rel="stylesheet" href="/assets/css/master-faq.css" />
      <main>
        {/* faq area start */}
        <section className="faq-area">
          <div className="container large">
            <div className="faq-area-inner section-spacing-bottom">
              <div className="section-content">
                <div className="btn-wrapper has_fade_anim" data-fade-from="left">
                  <a href="/contact" className="wc-btn wc-btn-underline">
                    {header.ctaText}
                    <i className="fa-solid fa-arrow-right" />
                  </a>
                </div>

                <div className="content-last">
                  <div className="section-title-wrapper">
                    <div className="title-wrapper">
                      <h1 className="section-title large has_fade_anim">
                        {header.title}
                      </h1>
                    </div>
                  </div>
                  <div className="text-wrapper">
                    <p className="text has_fade_anim" data-delay="0.30">
                      {header.description}
                    </p>
                  </div>

                  <div className="accordion-wrapper has_fade_anim" data-delay="0.45">
                    <div className="accordion accordion-flush" id="accordionFlushExample">
                      {faqs.map((faq, index) => {
                          const headingId = `flush-heading-${faq.id || index}`;
                          const collapseId = `flush-collapse-${faq.id || index}`;
                          return (
                            <div className="accordion-item" key={faq._id || faq.id || index}>
                              <h2 className="accordion-header" id={headingId}>
                                <button
                                  className="accordion-button collapsed"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target={`#${collapseId}`}
                                  aria-expanded="false"
                                  aria-controls={collapseId}
                                >
                                  {index + 1}. {faq.question}
                                </button>
                              </h2>
                              <div
                                id={collapseId}
                                className="accordion-collapse collapse"
                                aria-labelledby={headingId}
                                data-bs-parent="#accordionFlushExample"
                              >
                                <div className="accordion-body">{faq.answer}</div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* faq area end */}
      </main>
    </>
  );
};

export default Faqs;
